<script>
export default {
    name: 'PermsCreateForm',
    props: {
        onformsubmit: {
            type: Function,
            required: true
            },
        validator: {
            type: Object,
            required: true
            },
        form: {
            type: Object,
            required: true
            }
    },
    data() {
        return {}
    },
}
</script>
<template>
    <b-form  id="form" @submit="onformsubmit" >
        <form-wrapper :validator="validator ">
        <form-group name="name" :label="$t('name')">
            <b-form-input
                v-model="form.name"
                class="border-primary"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="codename" label="Codename">
            <b-form-input
                v-model="form.codename"
                class="border-primary"
                slot-scope="{ attrs, listeners }"
                v-bind="attrs"
                v-on="listeners"
            /> 
        </form-group>
        <form-group name="permission_type">
            <b-form-checkbox
            v-model="form.permission_type"
            value=3
            unchecked-value=2
            >
                ¿Es un permiso tipo API ?
            </b-form-checkbox>
        </form-group>
                                    
        <form-group name="description" :label="$t('description')">
            <div>
                <b-form-textarea
                    class="border-primary"
                    id="textarea"
                    v-model="form.description"
                    :placeholder="$t('description')"
                ></b-form-textarea>
            </div>
        </form-group> 
        </form-wrapper>
    </b-form>
</template>